var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExport = function SvgExport(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3H3V21H5H8H16V14H8V10H16V5.5L13.5 3H8H5ZM17.3859 9.00418L18.8001 7.58997L23.2143 12.0042L18.8001 16.4184L17.3859 15.0042L18.9935 13.3966C19.0399 13.3501 19.0631 13.3269 19.0876 13.3055C19.1602 13.2417 19.2417 13.1888 19.3296 13.1484C19.3591 13.1349 19.3898 13.1231 19.4511 13.0996L19.7002 13.0042H9L9.00018 11.0042H19.7002L19.4511 10.9087C19.3898 10.8853 19.3591 10.8735 19.3296 10.8599C19.2417 10.8195 19.1602 10.7667 19.0876 10.7029C19.0632 10.6815 19.04 10.6583 18.9937 10.612L18.9937 10.612L18.9936 10.6118L18.9935 10.6118L17.3859 9.00418Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExport);
export default ForwardRef;